import { HttpErrorResponse } from '@angular/common/http';

/**
 * The headers of an HttpErrorResponse are stored as a map. This function converts them to an object
 * so that JSONPath expressions can be used against them.
 */
export function convertHTTPHeaders(errorResponse: HttpErrorResponse | undefined): HTTPResponseHeaders {
  const headers: Record<string, string[] | null> = {};
  errorResponse?.headers?.keys()?.forEach((key) => {
    headers[key] = errorResponse.headers.getAll(key);
  });
  return headers as HTTPResponseHeaders;
}

export type HTTPResponseHeaders = Record<string, string[]>;
